import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { seller, sellerType } from '../../types/slices/sellerType'

const initialState: sellerType =
{
    status: ApiStatus.FETCHED,
    sellers: [],
    sellerSelected: {} as seller,
    errorMessage: undefined,
    action: ''
}

const sellerSlice = createSlice({
    name: 'sellerSlice',
    initialState,
    reducers: {
        onFetchSellers (state, { payload }: { payload: seller[]}) {
            state.status = ApiStatus.FETCHED
            state.sellers = payload
            state.errorMessage = undefined
        },
        onSetSelectedSeller (state, { payload }: { payload: seller }) {
            state.sellerSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectSellerState = (state: RootState) => state.sellerSlice
export default sellerSlice.reducer
export const {
    onFetchSellers,
    onSetSelectedSeller,
    changeStatus,
    setAction,
} = sellerSlice.actions
